import PropTypes from "prop-types"
import React from "react"

const texts = {
  pt: [
    <span>
      Conheça outros centros
      <br />
      Nacionais de Coordenação
    </span>,
    <ul>
      <li>Edimburgo, Escócia</li>
      <li>Holanda</li>
      <li>Ottawa, Canadá</li>
    </ul>,
    <ul>
      <li>Berlin, Alemanha</li>
      <li>São Francisco, Estados Unidos</li>
      <li>Tasmânia, Austrália</li>
    </ul>,
  ],
  en: [
    <span>
      Discover other National
      <br />
      Coordination centres
    </span>,
    <ul>
      <li>Edinburgh, Scotland </li>
      <li>Holand</li>
      <li>Ottawa, Canada</li>
    </ul>,
    <ul>
      <li>Berlin, Germany</li>
      <li>San Francisco, United States of America</li>
      <li>Tasmania, Australia</li>
    </ul>,
  ],
}

function OtherCamarades({ language }) {
  const text = texts[language]

  return (
    <section className="grey-linear-grad">
      <div className="container">
        <div className="row">
          <div className="col-md-6 d-flex align-items-center">
            <h2>{text[0]}</h2>
          </div>
          <div className="col-md-6 row">
            <div className="col-6 d-flex align-items-center">{text[1]}</div>
            <div className="col-6 d-flex align-items-center">{text[2]}</div>
          </div>
        </div>
      </div>
    </section>
  )
}

OtherCamarades.propTypes = {
  language: PropTypes.oneOf(["pt", "en"]),
}

export default OtherCamarades
